module.exports = __webpack_public_path__ + "static/img/sf4.704029f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sf4.png
// module id = 5mIy
// module chunks = 1